<h1>{{ 'RegisterService::QrNoLongerExists' | abpLocalization }}</h1>
